/**
 * @generated SignedSource<<780438f0e7b76af11f07c125a1bcfb10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LeadStageStatus = "active" | "lost" | "won";
export type leadsKanbanStagesQuery$variables = {
  id: string;
};
export type leadsKanbanStagesQuery$data = {
  readonly me: {
    readonly isAdmin: boolean | null;
  } | null;
  readonly pipelineById: {
    readonly stages: ReadonlyArray<{
      readonly id: string;
      readonly label: string;
      readonly status: LeadStageStatus;
    }>;
  } | null;
};
export type leadsKanbanStagesQuery = {
  response: leadsKanbanStagesQuery$data;
  variables: leadsKanbanStagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "LeadStage",
  "kind": "LinkedField",
  "name": "stages",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdmin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "leadsKanbanStagesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Pipeline",
        "kind": "LinkedField",
        "name": "pipelineById",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "leadsKanbanStagesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Pipeline",
        "kind": "LinkedField",
        "name": "pipelineById",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a2fb75351c8fd81d6bc9dcf0fbea19fb",
    "id": null,
    "metadata": {},
    "name": "leadsKanbanStagesQuery",
    "operationKind": "query",
    "text": "query leadsKanbanStagesQuery(\n  $id: ID!\n) {\n  pipelineById(id: $id) {\n    stages {\n      id\n      label\n      status\n    }\n    id\n  }\n  me {\n    isAdmin\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "adb7b732099fa0bacb43488c07e22d01";

export default node;
